module.exports = __webpack_public_path__ + "static/media/devon.2654ea2c.png";